import{connect}from'react-redux';import{fetchProductLocations}from"../../actions";/**
 * @param {Function} dispatch The redux dispatch function.
 * @return {Object} The extended component props.
 */var mapDispatchToProps={fetchProductLocations:fetchProductLocations};export default connect(null,mapDispatchToProps);